import { FormJourneyItem, LeadForm } from "@plura/shared/types";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@plura/shared/utils";
import "./opinion-scale-screen.css";
import RadioGroup from "../../../../molecules/RadioGroup";
import { useFormContext } from "react-hook-form";
import { dynamicQuestionContent, getCurrentResponseScore } from "@plura/shared/lead-forms";

interface Props {
  id: string;
  step: FormJourneyItem
  leadForm: LeadForm;
  editorMode: boolean;
  previewMode: boolean;
  active: boolean;
  handleAnswer?: () => void;
  onContentClick?: (fieldName: string, blockId: string) => void;
  hiddenFields?: {
    field: string;
    value: string;
  }[];
}

const OpinionScaleScreen = ({ id, step, editorMode, previewMode, leadForm, active, handleAnswer, onContentClick, hiddenFields }: Props) => {
  const minRange = step.minRange ?? 1
  const maxRange = step.maxRange ?? 10
  const rangeArray = Array.from({ length: maxRange - minRange + 1 }, (_, i) => minRange + i)
  const form = useFormContext();
  const { conversationId, ...userResponses } = form.getValues()
  const currentResponseScore = userResponses
    ? getCurrentResponseScore(userResponses, leadForm)
    : 0

  const handleContentClick = (field: 'content' | 'secondaryContent') => {
    if ((!editorMode || (editorMode && previewMode)) || !onContentClick) return
    onContentClick(field, id)
  }

  return (
    <>
      <div className={cn('questionInner')}>
        <div>
          <h4 className={cn('question')} onClick={() => handleContentClick('content')}>
            <motion.span
              dangerouslySetInnerHTML={{
                __html: dynamicQuestionContent({
                  content: step.content,
                  score: currentResponseScore,
                  editMode: editorMode,
                  previewMode: previewMode ?? false,
                  hiddenFields,
                  journeyItems: leadForm.journeyItems ?? [],
                  userResponses
                })
              }}
            />
          </h4>
          {
            step.secondaryContent &&
            <p className={cn('caption')} onClick={() => handleContentClick('secondaryContent')}>
              <motion.span
                dangerouslySetInnerHTML={{
                  __html: dynamicQuestionContent({
                    content: step.secondaryContent,
                    score: currentResponseScore,
                    editMode: editorMode,
                    previewMode: previewMode ?? false,
                    hiddenFields,
                    journeyItems: leadForm.journeyItems ?? [],
                    userResponses
                  })
                }}
              />
            </p>
          }
        </div>
        <div>
          <motion.div className={'answerInputWrapper'}>
            <AnimatePresence initial={false}>
              <motion.div className={'fieldWrapper'}>
                <div className={'rangeWrapper'}>
                  <RadioGroup
                    id={step.blockId}
                    adaptiveUI
                    minLabel={
                      step.minLabel
                        ? <><b>{minRange} -&nbsp;</b>{step.minLabel}</>
                        : undefined
                    }
                    maxLabel={step.maxLabel
                      ? <><b>{maxRange} -&nbsp;</b>{step.maxLabel}</>
                      : undefined
                    }
                    disabledKeySelection={(editorMode && !previewMode) || !active}
                    options={rangeArray.map(value => ({
                      value: value.toString(),
                      label: value.toString()
                    }))}
                    item={(value, checked) => (
                      <div className={'rangeItem'}>
                        {value}
                      </div>
                    )}
                    handleOnChange={handleAnswer}
                  />
                </div>
              </motion.div>
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </>
  );
};


export default OpinionScaleScreen